// extracted by mini-css-extract-plugin
module.exports = {"input":"input--NIH5w","editing":"editing--BXpJE","enter":"enter--twGBS","delete":"delete--6InaX"};
    if(module.hot) {
      // 1653630378677
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  